import { CircularProgress, Grid, Typography } from '@mui/material';

import { Logo } from '../fa-logo';

export interface IProps {
  text?: string;
  showLogo?: boolean;
}

const Loading = (props: IProps) => {
  const { text, showLogo } = props;
  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'>
      {showLogo && <Logo />}
      <Typography
        variant='h6'
        sx={{ fontWeight: 300, marginBottom: (theme) => theme.spacing(2) }}>
        {text || 'loading...'}
      </Typography>
      <CircularProgress />
    </Grid>
  );
};
export default Loading;
